export default __webpack_public_path__ + "static/media/staten.fd326809.png";